import api from './api';

const decisionSupportService = {
  // Get recommendations
  getRecommendations: async (params = {}) => {
    try {
      const response = await api.get('/decision-support/recommendations', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      throw error;
    }
  }
};

export default decisionSupportService;